import { CRUDFabric } from "../CRUDs/CRUDFabric";
import { Customer } from "../CRUDs/entities/Customer";
import { Invoice } from "../CRUDs/entities/Invoice";
import { Job } from "../CRUDs/entities/Job";
import { JobRequest } from "../CRUDs/entities/JobRequest";
import { Visit } from "../CRUDs/entities/Visit";

export default{
    init(){
        this.initshowButton();
        this.projectsActions();
        this.visitActions();
        this.requestActions();
        this.hidedSelectBehavior();
        this.quoteActions();
        this.jobActions();
        this.invoiceActions();
        this.filesActions();
        this.changeStatus();
        this.initLogs();
        this.resizeCommentField();
        this.initConfirmationsForms();
        this.showMore();
        this.callCenterModal();
    },


    initshowButton(){
        $('body').on('click','.show-actual-jobs', (e)=>{
            const id = $(e.currentTarget).parents('tr').data('id');
            $('.bb-preloader-container').show();
            $.ajax({
                type: 'POST',
                url: '/jobs-flow/customer-projects-modal',
                data: ({
                    id: id,
                }),
                success: function (response) {
                    $('#form-container-s').html(response);
                    $('#customer-projects-modal').modal('show');
                    $('.bb-preloader-container').hide();
                }
            });
        });
    },
    projectsActions(entity_id = null){
        $('body').on('click','#customer-projects-modal .select-request-btn',(e)=> {
            const entity_id = $(e.currentTarget).parents('tr').data('entity_id');

            this.getJobRequest(entity_id);
            /* $.ajax({
                method: 'POST',
                url: '/jobs-flow/get-job-request-info',
                data: {
                    entity_id: entity_id
                },
                success: (response) => {
                    $('#customer-projects-modal').find('.section').removeClass('active');
                    $('#customer-projects-modal').find('.section.job-request').html(response.view);
                    $('#customer-projects-modal').find('.section.job-request').addClass('active');
                    $('#customer-projects-modal').find('.project-step.job-request').addClass('active').addClass('fw-500').addClass('focused');
                    $('#customer-projects-modal').find('.project-name').text(response.service_name);
                    $('#customer-projects-modal').find('.project-details').text(response.request_date);
                    const request =  new JobRequest(entity_id);

                    request.scopeOpenDropZoneListener({}, this.getEntityInfo);
                    request.setAttachmentCallbackDelete();
                    let progress = Object.keys(response.progress).map((key) => [key, response.progress[key]]);
                    $('#customer-projects-modal').find(`.project-step:not(.job-request):not(.projects)`).removeClass('active');
                    progress.forEach(element => {
                        if (element[1] == true) {
                            $('#customer-projects-modal').find(`.project-step.${element[0]}`).addClass('active');
                        }
                    });
                    $('.loader-bg').hide();
                },
                error: (response) => {
                    $('.loader-bg').hide();
                    this.showResultMessage('active', 'error', 'Something went wrong, please try again later or submit a <a class="text-underline create-ticket" href="#">ticket</a>.');
                }
            }); */
        });
        $('body').on('click', '#customer-projects-modal .next-step', (e) => {
            const next_step = $(e.target).data('next');
            const entity_id = $(e.target).data('entity_id');
            this.getEntityInfo(next_step, entity_id, false);
            const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
            this.scopeDropZone(type,entity_id);
        });
        $('body').on('click', '#customer-projects-modal .project-step', (e) => {
            if ($(e.currentTarget).hasClass('active')) {
                let classList = $(e.currentTarget)[0].classList;
                const section_name = classList[1];
                $('#customer-projects-modal').find(`.project-step`).removeClass('fw-500').removeClass('focused');
                if (!$(e.currentTarget).hasClass('projects')) {
                    $(e.currentTarget).addClass('fw-500').addClass('focused');
                }
                const job_request_id = $('#selected_request').val();
                const entity_id = section_name == ('job-request') ? job_request_id : false;
                if ( $(e.currentTarget).hasClass('projects') || $(e.currentTarget).hasClass('customer')) {
                    $('#customer-projects-modal').find(`.section.active`).removeClass('active');
                    $('#customer-projects-modal').find(`.section.${section_name}`).addClass('active');
                }else{
                    this.getEntityInfo(section_name,job_request_id, entity_id);
                    const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
                    this.scopeDropZone(type,entity_id);
                }
            }
        });
        $('body').off('click', '#customer-projects-modal .section:not(.customer) .edit-customer-info-btn').on('click', '#customer-projects-modal .section:not(.customer) .edit-customer-info-btn', function(e) {
            const customer_id = $(this).data('id');
            const customer = new Customer(customer_id);
            customer.callbackCloseModal = () => {
                $(`#edit-customer-modal`).modal('hide');
                $('#customer-projects-modal #r_s').change();
            };
            customer.openModal('edit');
        });
        $('body').on('click', '#customer-projects-modal .create-ticket', function(e) {
            $('#open_help_ticket_form').click();
        });
        $('body').on('click', '#customer-projects-modal .cancel-editing', (e)=> {
            let entity_id = $(e.currentTarget).parent().data('id');

            this.getEntityInfo(null, null, entity_id);

        });
    },
    getJobRequest(entity_id, sCallback = ()=> {}){
        $('#selected_request').val(entity_id);
        $.ajax({
            method: 'POST',
            url: '/jobs-flow/get-job-request-info',
            data: {
                entity_id: entity_id
            },
            beforeSend: () =>{
                $('.loader-bg').show();
            },
            success: (response) => {
                $('#customer-projects-modal').find('.section').removeClass('active');
                $('#customer-projects-modal').find('.section.job-request').html(response.view);
                $('#customer-projects-modal').find('.section.job-request').addClass('active');
                $('#customer-projects-modal').find('.project-step.job-request').addClass('active').addClass('fw-500').addClass('focused');
                $('#customer-projects-modal').find('.project-name').text(response.service_name);
                $('#customer-projects-modal').find('.project-details').text(response.request_date);
                const request =  new JobRequest(entity_id);

                request.scopeOpenDropZoneListener({}, this.getEntityInfo);
                request.setAttachmentCallbackDelete();
                let progress = Object.keys(response.progress).map((key) => [key, response.progress[key]]);
                $('#customer-projects-modal').find(`.project-step:not(.job-request):not(.projects):not(.customer)`).removeClass('active');
                progress.forEach(element => {
                    if (element[1] == true) {
                        $('#customer-projects-modal').find(`.project-step.${element[0]}`).addClass('active');
                    }
                });
                $('.loader-bg').hide();
            },
            error: (response) => {
                $('.loader-bg').hide();
                this.showResultMessage('active', 'error', 'Something went wrong, please try again later or submit a <a class="text-underline create-ticket" href="#">ticket</a>.');
            },
            complete: sCallback
        });
    },
    getEntityInfo(next_step=null, job_request_id=null, entity_id=null, change_focus=true){
        $('.loader-bg').show();
        if (typeof next_step !== "string") {
            next_step = $('.section.active')[0].classList[1];
        }
        if (job_request_id == null) {
            job_request_id = $('.section.active #request_id').val();
        }
        if (entity_id == null) {
            entity_id = $('.section.active #entity_id').val();
        }
        //console.log('getEntityInfo',next_step, job_request_id, entity_id);
        $.ajax({
            method: 'POST',
            url: `/jobs-flow/get-${next_step}-info`,
            data: {
                job_request_id: job_request_id,
                entity_id: entity_id
            },
            success: (response) => {
                $('#customer-projects-modal').find(`.section.${next_step}`).html(next_step == 'job-request' ? response.view : response);
                if (change_focus) {
                    $('#customer-projects-modal').find('.section').removeClass('active');
                    $('#customer-projects-modal').find(`.section.${next_step}`).addClass('active');
                    $('#customer-projects-modal').find(`.project-step`).removeClass('fw-500').removeClass('focused');
                    $('#customer-projects-modal').find(`.project-step.${next_step}`).addClass('fw-500').addClass('focused');
                }
                $('#customer-projects-modal').find(`.project-step.${next_step}`).addClass('active')
                $('.loader-bg').hide();
            },
            error: (response) => {
                $('.loader-bg').hide();
                this.showResultMessage('active', 'error', 'Something went wrong, please try again later or submit a <a class="text-underline create-ticket" href="#">ticket</a>.');
            }
        });
    },
    scopeDropZone(type,entity_id){
        if (type && entity_id) {
            const entityClass = CRUDFabric.getClass(type);
            const entity = new entityClass(entity_id);
            entity.scopeOpenDropZoneListener({}, this.getEntityInfo);
            entity.setAttachmentCallbackDelete();
        }
    },
    requestActions(){
        $('body').on('click', '#customer-projects-modal .edit-request-details', function(e) {
            if (!$(this).hasClass('editing')) {
                $(this).addClass('editing');
                $(this).find('div').text('Editing');
                $('#customer-projects-modal .request-details-container').find('textarea').removeAttr('disabled');
                $('#customer-projects-modal .section.active').find('.btn').addClass('d-none');
                $('#customer-projects-modal button.save-request-changes').removeClass('d-none');
                $('#customer-projects-modal button.cancel-editing').removeClass('d-none');
                $('#customer-projects-modal .section.active').find('.status-select').addClass('editing');

                $('#customer-projects-modal .request-details-container').find('.request-description-row').find('.request-description-row-value:not(.static)').addClass('d-none');
                $('#customer-projects-modal .request-details-container').find('.request-description-row').find('.hided-select-container').removeClass('d-none');
            }
        });
        $('body').on('click', '#customer-projects-modal .save-request-changes', (e) => {
            $('.loader-bg').show();
            $('#customer-projects-modal .section.active').find('.btn').attr('disabled', true);
            const request_id = $('#customer-projects-modal #request_id').val();
            const request = new JobRequest(request_id);

            request.update(this.successUpdateRequestCallback, this.errorCallback);

        });
        $('body').on('click', '#customer-projects-modal .approve-request-btn', (e) => {
            $(e.currentTarget).parent().find('.btn').attr('disabled', true);
            const job_request_id = $(e.currentTarget).parent().data('id');
            $.ajax({
                method: 'POST',
                url: `/jobs-flow/request/${job_request_id}/approve?result_message=true`,
                success: (response) => {
                    this.showResultMessage('job-request', 'success', response);
                    setTimeout(() => {
                        this.getEntityInfo('job-request', job_request_id, job_request_id);
                    }, 2000);
                },
                error: (response) => {
                    console.log(response);
                }
            })
        });
        $('body').on('click', '#customer-projects-modal .cancel-request-btn', (e) => {
            $(e.currentTarget).parent().find('.btn').attr('disabled', true);
            const job_request_id = $(e.currentTarget).parent().data('id');
            $.ajax({
                method: 'POST',
                url: `/jobs-flow/request/${job_request_id}/cancel?result_message=true`,
                success: (response) => {
                    this.showResultMessage('job-request', 'success', response);
                    setTimeout(() => {
                        this.getEntityInfo('job-request', job_request_id, job_request_id);
                    }, 2000);
                },
                error: (response) => {
                    console.log(response);
                }
            })
        });
        $('body').on('change', '#customer-projects-modal #r_s', (e) => {
            const job_request_id = $(e.currentTarget).parent().find('#request_id').val();
            this.getEntityInfo('job-request', job_request_id, job_request_id);
        });
    },
    successUpdateRequestCallback(r){
        $('#customer-projects-modal #r_s').change();
        $('.loader-bg').hide();
    },
    successUpdateJobCallback(r){
        $('#customer-projects-modal .edit-job-details').removeClass('editing');
        $('#customer-projects-modal .edit-job-details').find('div').text('Edit');
        $('#customer-projects-modal .edit-job-details').find('.current-job-status').removeClass('d-none');
        $('#customer-projects-modal .job-details-container').find('textarea').attr('disabled', 'disabled');
        $('#customer-projects-modal .job-details-container').find('.job-description-row').find('.job-description-row-value').removeClass('d-none');
        $('#customer-projects-modal .job-details-container').find('.job-description-row').find('.hided-select-container').addClass('d-none');
        $('#customer-projects-modal button.next-step').removeClass('d-none');
        $('#customer-projects-modal button.save-job-details').addClass('d-none');
    },

    errorCallback(response){
        let message = 'Something went wrong, please try again later or submit a <a class="text-underline create-ticket" href="#">ticket</a>.';
        if (response.error_message) {
            message = response.error_message;
        }
        let messageHtml = `<div class="message error">`+
        `<div><img src="/images/individual-jobs/error-checkmark.png"></div>`+
        `<div>${message}</div>`+
        `</div>`;
        $(`.section.active .result-message-container`).addClass('d-block');
        $(`.section.active .result-message-container`).html(messageHtml);
        $(`.section.active .actions`).find('.btn').removeAttr('disabled');
        $('.loader-bg').hide();
    },
    visitActions(){
        $('body').on('click','.create-visit-btn', function(e) {
            $.ajax({
                method: 'POST',
                url: '/jobs-flow/create-entity-form',
                data: {
                    entity: 'visit',
                    job_request_id: $(this).data('job_request_id'),
                },
                success: (response) => {
                    $('#customer-projects-modal .section.active .entity-info-container').html(response);
                    $('#customer-projects-modal').find('.cancel-visit-btn').removeClass('d-none');
                    $('#customer-projects-modal').find('.save-visit-btn').removeClass('d-none');
                    $('#customer-projects-modal').find('.next-step').addClass('d-none');
                    $('#customer-projects-modal').find('#visit_preffered_date').datetimepicker({
                        format: 'ddd, MMM D',
                        defaultDate: new Date(),
                    });
                    $('#customer-projects-modal').find('#visit_preffered_date').on('dp.change',(e) => {
                        let picker = $(e.target).data('DateTimePicker');
                        // let dayNumber = picker.date().format('D');
                        // var suffix = "";
                        // switch(dayNumber) {
                        //     case '1': case '21': case '31': suffix = 'st'; break;
                        //     case '2': case '22': suffix = 'nd'; break;
                        //     case '3': case '23': suffix = 'rd'; break;
                        //     default: suffix = 'th';
                        // }
                        // $(e.target).val($(e.target).val()+suffix);
                        let date_input = $(e.target).parent().find('input[name="date"]');
                        date_input.val(picker.date().format('Y-M-D'));
                    });
                },
                error: (response) => {

                }
            });
        })
        $('body').on('click', '#customer-projects-modal .status-select', function(e) {
            const options_container = $(this).find('.status-select-options-container');
            if (options_container.hasClass('d-none')) {
                options_container.removeClass('d-none');
            } else {
                options_container.addClass('d-none');
            }
            let posX = 0;
            let posY = 30;
            options_container.css({left: posX, top: posY});
        });
        $('body').on('click', '#customer-projects-modal .workers-select', function(e) {
            if (!$(e.target).hasClass('worker-row')) {
                const workers_container = $(this).find('.workers-list');
                workers_container.toggleClass('d-none');

                let posX = 0;
                let posY = 50;
                workers_container.css({left: posX, top: posY});
            }
        });
        $('body').on('click', '#customer-projects-modal .worker-row', function(e) {
            let parent = $(this).parents('.workers-select');
            let selectedValue = $(parent).find('.selected-workers').text();
            if ($(this).hasClass('selected')) {
                $(this).find('input').removeAttr('checked');
            } else {
                $(this).find('input').attr('checked', 'checked');
            }
            $(this).toggleClass('selected');

            console.log('#customer-projects-modal .worker-row', selectedValue);
            let selecetedInputs = $(parent).find('.worker-row.selected').toArray();
            let result = '';
            selecetedInputs.forEach(element => {
                if (result == '') {
                    result += $(element).find('input').val();
                } else {
                    result += ', '+$(element).find('input').val();
                }
            });
            /* if (selectedValue == '') {
                $(parent).find('.selected-workers').text($(this).find('input').val());
            } else {
            } */
            $(parent).find('.selected-workers').text(result);
        });
        $('body').on('click', '#customer-projects-modal .save-visit-btn', (e)=> {
            $('.loader-bg').show();
            $('#customer-projects-modal .section.active').find('.btn').attr('disabled', true);
            if ($('.section.visit #entity_id').val()>0) {
                let visit = new Visit($('.section.visit #entity_id').val());
                visit.update(()=>{}, this.errorCallback);
            }else{
                let visit = new Visit();
                visit.create(()=>{}, this.errorCallback);
            }
            let entity_id = $('.section.visit #entity_id').val();
            setTimeout(() => {
                this.getEntityInfo('visit', $('.section.visit #job_request_id').val(), $('.section.visit #entity_id').val() ?? null);
                const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
                this.scopeDropZone(type,entity_id);
            }, 2000);
        })
        $('body').on('click', '#customer-projects-modal .schedule-container', (e) => {
            let entity_id = $(e.currentTarget).data('entity_id');
            const job_request_id = $(e.currentTarget).data('job_request_id');
            const entity_type = $(e.currentTarget).data('entity_type');

            this.getEntityInfo(entity_type, job_request_id, entity_id);
            const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
            this.scopeDropZone(type,entity_id);
        });
        $('body').on('click', '#customer-projects-modal .edit-visit-btn', (e) => {
            $.ajax({
                method: 'POST',
                url: '/jobs-flow/create-entity-form',
                data: {
                    entity: 'visit',
                    job_request_id: $(e.currentTarget).data('job_request_id'),
                    entity_id: $(e.currentTarget).data('entity_id'),
                },
                success: (response) => {
                    $('#customer-projects-modal .section.visit .entity-info-container').html(response);
                    $('#customer-projects-modal').find('.cancel-visit-btn').removeClass('d-none');
                    $('#customer-projects-modal').find('.save-visit-btn').removeClass('d-none');
                    $('#customer-projects-modal').find('.next-step').addClass('d-none');
                    $('#customer-projects-modal').find('#visit_preffered_date').datetimepicker({
                        format: 'ddd, MMM D, Y',
                        defaultDate: new Date(),
                    });
                    $('#customer-projects-modal').find('#visit_preffered_date').on('dp.change',(e) => {
                        let picker = $(e.target).data('DateTimePicker');
                        let date_input = $(e.target).parent().find('input[name="date"]');
                        date_input.val(picker.date().format('Y-M-D'));
                    });
                },
                error: (response) => {

                }
            });
        });
        $('body').on('click', '#customer-projects-modal .cancel-visit-btn', (e) => {
            const visit_id = $('#edit-visit').find('#entity_id').val();
            const job_request_id = $('#edit-visit').find('#job_request_id').val();
            this.getEntityInfo('visit', job_request_id,visit_id);
        })
    },

    quoteActions(){
        $('body').on('click', '#customer-projects-modal .create-quote-btn', (e) => {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }
            let job_request_id = $(e.target).data('request_id');
            this.openLinkInNewTab(`/jobs-flow/quote/create?job_request_id=${job_request_id}`, true);
            $(e.currentTarget).addClass('disabled');
            this.onFocusEvent('quote', job_request_id, null);
        });
        $('body').on('click', '#customer-projects-modal .edit-quote-btn', (e) => {
            let id = $(e.currentTarget).data('id');
            this.openLinkInNewTab(`/jobs-flow/quote/${id}/edit`, true);
        });
        $('body').on('click', '#customer-projects-modal .quote-download-pdf', (e) => {
            let id = $(e.currentTarget).data('id');
            this.openLinkInNewTab(`/jobs-flow/quote/${id}/pdf`, true);
        });
    },

    jobActions(){
        $('body').on('click', '#customer-projects-modal  .create-job-btn', (e) => {
            const job_request_id = $(e.currentTarget).data('id');
            $.ajax({
                method: 'POST',
                url: `/jobs-flow/request/${job_request_id}/convert-to-job`,
                success: (response) => {
                    const entity_type = 'job';
                    this.getEntityInfo(entity_type, job_request_id, null);
                },
                error: (response)=>{
                    console.log(response);
                }
            });
        });
        $('body').on('click', '#customer-projects-modal  .edit-job-details', (e) => {
            if (!$(e.currentTarget).hasClass('editing') && !$(e.currentTarget).hasClass('creating')) {
                $(e.currentTarget).addClass('editing');
                $(e.currentTarget).find('div').text('Editing');
                $('#customer-projects-modal .job-details-container').find('textarea').removeAttr('disabled');
                $('#customer-projects-modal .section.active button.save-job-details').removeClass('d-none');
                $('#customer-projects-modal .section.active button.cancel-editing').removeClass('d-none');
                $('#customer-projects-modal .section.active button.next-step').addClass('d-none');

                $('#customer-projects-modal .job-details-container').find('.job-description-row').find('.job-description-row-value:not(.static)').removeClass('d-flex').addClass('d-none');
                $('#customer-projects-modal .job-details-container').find('.job-description-row').find('.hided-select-container').removeClass('d-none');
                $('#customer-projects-modal .job-details-container').find('.hided-select-container').find('.save-job-workers').addClass('d-none');
            }
        });
        $('body').on('click', '#customer-projects-modal .save-job-details', (e) => {
            const job_id = $(e.currentTarget).data('id');
            const job_request_id = $(e.currentTarget).data('entity_id');
            const job = new Job(job_id);
            const entity_type = 'job';
            job.update(this.successUpdateJobCallback,this.errorCallback);
            this.getEntityInfo(entity_type, job_request_id, null);
        });
        $('body').on('click', '#customer-projects-modal .edit-job-workers', (e) => {
            const elem = $(e.currentTarget);
            const row = elem.parents('.job-description-row');
            $(row).find('.job-description-row-value').removeClass('d-flex').addClass('d-none');
            $(row).find('.hided-select-container').toggleClass(['d-none', 'd-flex']);
        });

        $('body').on('click', '#customer-projects-modal .save-job-workers', (e) => {
            const job_id = $(e.currentTarget).data('id');
            if (job_id !=='') {
                $('.loader-bg').show();
                const job = new Job(job_id);
                try {
                    job.assingWorkers(()=>{}, '.section.job');
                    this.getEntityInfo('job', $(e.currentTarget).parents('#edit-job').find('#request_id').val(), job_id);
                } catch (error) {
                    $('.loader-bg').hide();
                }
            }
        });

        $('body').off('click','#customer-projects-modal .leave-comments').on('click','#customer-projects-modal .leave-comments', (e) => {
            const entityType = $(e.currentTarget).data('type');
            const entityId = $(e.currentTarget).data('job-id');
            $('#leave-comments-modal').modal('show');
            $('#leave-comments-modal').find('textarea').val('');
            $('#leave-comments-modal button.comment-button').data('job-id', entityId);
            $('#leave-comments-modal button.comment-button').data('type', entityType);
        });
    },

    invoiceActions(){
        $('body').on('click', '#customer-projects-modal .create-invoice-btn', (e) => {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }
            let job_request_id = $(e.target).data('request_id');
            this.openLinkInNewTab(`/jobs-flow/invoice/create?job_request_id=${job_request_id}`, true);
            $(e.currentTarget).addClass('disabled');
            this.onFocusEvent('invoice', job_request_id, null);
        });
        $('body').on('click', '#customer-projects-modal .invoice-download-pdf', (e) => {
            let id = $(e.currentTarget).data('id');
            this.openLinkInNewTab(`/jobs-flow/invoice/${id}/pdf`, true);
        });
        $('body').on('click', '#customer-projects-modal .edit-invoice-btn', (e) => {
            let id = $(e.currentTarget).data('id');
            this.openLinkInNewTab(`/jobs-flow/invoice/${id}/edit`, true);
            this.onFocusEvent('invoice', job_request_id, null);
        });
        $('body').on('click', '#customer-projects-modal .exit-preview-invoice-btn', (e) => {
            let id = $(e.currentTarget).data('entity_id');
            this.getEntityInfo('invoice', id, null);
        });
        $('body').on('click', '#customer-projects-modal .refund-invoice-btn', (e) => {
            let id = $(e.currentTarget).data('entity_id');
            const invoice = new Invoice(id);
            invoice.refundForm();
        });
    },

    onFocusEvent(next_step, job_request_id, entity_id){
        window.onfocus = () =>{
            this.getEntityInfo(next_step, job_request_id, entity_id);
            window.onfocus = () => {};
        }
    },

    hidedSelectBehavior(){
        $('body').on('click', '#customer-projects-modal .hided-select', function(e) {
            let opened_options = $('.hided-select-options.opened').toArray();
            opened_options.forEach(element => {
                if ($(element).is($(this).find('.hided-select-options.opened'))) {
                    return;
                }
                $(element).removeClass('opened');
            });
            $(this).find('.hided-select-options').toggleClass('opened');
        });
        $('body').on('click', '#customer-projects-modal .hided-select-option', function(e) {
            let parent = $(this).parents('.hided-select');
            parent.find('.selected-value').attr('value', $(this).attr('value'));
            parent.find('.selected-value').text($(this).text());
            parent.find('input').val($(this).attr('value'));
        });
    },

    showResultMessage(section, type, message){
        let messageHtml = `<div class="message ${type}">`+
        `<div><img src="/images/individual-jobs/${type}-checkmark.png"></div>`+
        `<div>${message}</div>`+
        `</div>`;
        console.log(`.section.${section} .result-message-container`);
        $(`.section.${section} .result-message-container`).addClass('d-block');
        $(`.section.${section} .result-message-container`).html(messageHtml);
    },

    openLinkInNewTab(link, focus=true){
        window.open(link, (focus==true ? '_blank' : ''));
    },

    filesActions(){
        $('body').on('click', '#customer-projects-modal .delete-attachment', function(e) {
            const file_id = $(this).data('file_id');
            const url = $(this).data('d_link');
            $.ajax({
                method: 'POST',
                url: url,
                data: {
                    fileId: file_id
                }
            });
        });
        $('body').on('click', '#customer-projects-modal .download-btn', (e) => {
            const url = $(e.currentTarget).data('d_link');
            this.openLinkInNewTab(url, false);
        });
    },

    changeStatus(){
        $('body').on('click', '.status-select .status-select-option', (e)=>{
            const parent = $(e.currentTarget).parents('.status-select');
            if ($(parent).hasClass('editing')) {
                $(parent).find('.selected-value').html($(e.currentTarget).html());
                $(parent).find('#status').val($(e.currentTarget).data('id'));
            } else {
                const entity = $(e.currentTarget).parents('.status-select').data('entity');
                const entity_id = $(e.currentTarget).parents('.status-select').data('entity_id');
                const status_id = $(e.currentTarget).data('name');
                if (!entity || !entity_id || !status_id) {
                    return;
                }
                this.updateStatus(entity,entity_id,status_id);
            }
        });
    },
    updateStatus(entity, entity_id, status_id, with_refresh=true){
        $.ajax({
            method: 'POST',
            url: `/jobs-flow/${entity}/${entity_id}/${status_id}`,
            success: (response) => {
                if (with_refresh) {
                    const next_step = (entity == 'request') ? 'job-request' : entity;
                    const job_request_id = (entity == 'request') ? entity_id : $(parent).data('job_request_id');
                    this.getEntityInfo(next_step,job_request_id,entity_id);
                }
            },
            error: (response) => {
                console.log(response);
            }
        });
    },

    initLogs(){
        $('body').off('click','entity-logs-btn')
        .on('click', '.entity-logs-btn', function() {
            const entity = $(this).data('entity');
            const entity_id = $(this).data('entity_id');
            const EntityObj = CRUDFabric.getObject(entity, entity_id);
            EntityObj.openModal('logs');
        })
    },

    resizeCommentField() {
        $('body').off('input', '#customer-projects-modal #comments').on('input', '#customer-projects-modal #comments', function() {
            this.style.cssText = 'height: auto';
            this.style.cssText = 'height:' + (this.scrollHeight+16) + 'px';
        });
    },

    initConfirmationsForms() {
        $('body').off('click', '#customer-projects-modal .project-step:not(.active)')
        .on('click', '#customer-projects-modal .project-step:not(.active)', function(){
            const entity = $(this).data('entity');
            const request_step = $('#customer-projects-modal .project-step.job-request');
            if (entity && request_step.hasClass('active')) {
                $.ajax({
                    method:'POST',
                    url: '/jobs-flow/get-confirmation-modal',
                    data: {
                        entity: entity,
                        job_request_id: $('#customer-projects-modal #selected_request').val(),
                    },
                    success: (response) =>{
                        if (response.need_confirm) {
                            $('#form-container').html(response.view);
                            $('#confirm-action-modal').modal('show');
                        } else {
                            if (entity == 'visit') {
                                $('.section.job-request .next-step').click();
                            }else if(entity == 'quote'){
                                $('.section.visit .next-step').click();
                            }else if (entity == 'job') {
                                $('.section.quote .next-step').click();
                            }else if(entity == 'invoice'){
                                $('.section.job .next-step').click();
                            }
                        }
                    },
                    error: (r) => {
                        console.log(r);
                    }
                });
            }
        });
        $('body').on('click', '#confirm-action-modal .confirm-btn', (e) =>  {
            const entity = $(e.currentTarget).data('entity');
            const entity_id = $("#customer-projects-modal #selected_request").val();
            if (entity == 'visit') {
                this.updateStatus('request', entity_id, 'approve', false);
                this.getEntityInfo(entity, entity_id, false);
                //const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
                this.scopeDropZone(entity,entity_id);
                $('#confirm-action-modal').modal('hide');
            }else if(entity == 'quote') {
                this.getEntityInfo(entity, entity_id, false);
                //const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
                this.scopeDropZone(entity,entity_id);
                $('#confirm-action-modal').modal('hide');
            }else if (entity == 'job') {
                $.ajax({
                    method: 'POST',
                    url: `/jobs-flow/request/${entity_id}/convert-to-job`,
                    success: (response) => {
                        const entity_type = 'job';
                        this.getEntityInfo(entity_type, entity_id, null);
                    },
                    error: (response)=>{
                        console.log(response);
                    }
                });
                $('#confirm-action-modal').modal('hide');
            }else if(entity == 'invoice'){
                if (e.currentTarget.hasAttribute('without-quote')) {
                    this.updateStatus('request', entity_id, 'approve', false);
                    this.getEntityInfo('invoice', entity_id, false);
                    //const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
                    //this.scopeDropZone(entity,entity_id);
                }
                if(e.currentTarget.hasAttribute('without-job')) {
                    $.ajax({
                        method: 'POST',
                        url: `/jobs-flow/request/${entity_id}/convert-to-job`,
                        success: (response) => {
                            const entity_type = 'job';
                            this.getEntityInfo(entity_type, entity_id, null, false);
                            this.getEntityInfo('invoice', entity_id, false);
                            const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
                            //this.scopeDropZone(type,entity_id);
                        },
                        error: (response)=>{
                            console.log(response);
                        }
                    });
                }
                if (!e.currentTarget.hasAttribute('without-quote') && !e.currentTarget.hasAttribute('without-job')) {
                    this.getEntityInfo('invoice', entity_id, false);
                    const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
                    //this.scopeDropZone(type,entity_id);
                }

                $('#confirm-action-modal').modal('hide');
            }
        });

        $('body').on('click', '#confirm-action-modal .cancel-btn', (e)=>{
            const entity_id = $("#customer-projects-modal #selected_request").val();
            if ($(e.currentTarget).data('entity') == 'visit') {
                this.getEntityInfo('visit', entity_id, false);
                const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
                this.scopeDropZone('visit',entity_id);
                $('#confirm-action-modal').modal('hide');
            }else{
                $('#confirm-action-modal').modal('hide');
            }
        });
    },

    showMore(){
        $('body').off('click', '#customer-projects-modal .show-more-btn')
        .on('click', '#customer-projects-modal .show-more-btn', function(e) {
            const curr_elem = $(this);
            let compressed_elem;
            if (curr_elem.hasClass('worker-comments')) {
                compressed_elem = curr_elem.find('.content-container');
            }else{
                compressed_elem = curr_elem.find('textarea, input');
            }
            if (e.target == this) {
                if (curr_elem.hasClass('opened')) {
                    curr_elem.removeClass('opened');
                    curr_elem[0].setAttribute('data-after', 'Show More');
                    compressed_elem.css({overflow:'', height: ''});
                } else {
                    let scrollH = compressed_elem[0].scrollHeight + 5;
                    compressed_elem.css({overflow:'auto', height: scrollH+'px'});
                    curr_elem[0].setAttribute('data-after', 'Hide');
                    curr_elem.addClass('opened');
                }
            }
        });

        $('body').off('click', '#customer-projects-modal .show-more-attachments-btn')
        .on('click', '#customer-projects-modal .show-more-attachments-btn', function(e) {
            const container = $(this);
            const entity = $(this).data('entity');
            const entity_id = $(this).data('entity_id');
            const step = $(this).data('step')+1;
            if (e.target == this) {
                $.ajax({
                    method: "POST",
                    url: '/jobs-flow/get-more-files',
                    data: {
                        entity: entity,
                        entity_id:entity_id,
                        step: step,
                    },
                    success: (r) => {
                        if (r.view) {
                            container.append(r.view);
                        }
                        if (r.many_files == false) {
                            container.removeClass('with-show-more');
                        }
                        $(this).data('step', step);
                    },
                    error: (r) => {

                    }
                });
            }
        });
    },

    callCenterModal(){
        $('body').on('click', '.right-sidebar-card.show-project-modal, .stafter-table-body-column.show-project-modal', (e) => {
            e.preventDefault();
            const customer_id = $(e.currentTarget).data('customer_id');
            const entity_id = $(e.currentTarget).data('entity_id');
            const entity = $(e.currentTarget).data('entity');
            const modelId = $(e.currentTarget).data('model_id');
            this.getProjectModal(customer_id, entity_id, entity,entity=='request' ? null : modelId);
        })
    },

    /**
     *
     * @param {Int} customer_id
     * @param {Int} entity_id
     * @param {String} step
     * @param {String} container_id
     * @param {callback} successCallback
     * @param {callback} errorCallback
     */
    getProjectModal(customer_id, entity_id, step='request', modelId=null, container_id="form-container-s", show_loader=true, successCallback=()=>{}, errorCallback = ()=>{}){
        if (Number.isInteger(customer_id)) {
            $.ajax({
                type: 'POST',
                url: '/jobs-flow/customer-projects-modal',
                data: ({
                    id: customer_id,
                    request_id: entity_id
                }),
                beforeSend: () => {
                    if (show_loader) {
                        $('.bb-preloader-container').show();
                    }
                },
                success: (response) => {
                    $(`#${container_id}`).html(response);
                    $('#customer-projects-modal').modal('show');
                    //const button = $(`#customer-projects-modal [data-entity_id=${entity_id}]`).find('.select-request-btn');
                    //button.click();
                    new Promise((resolve, reject) => {
                        //this.getNeedEntity('request');
                        if (step !== 'customer') {
                            this.getJobRequest(entity_id, ()=>{resolve()});
                        }else{
                            resolve();
                        }
                        //resolve();
                    }).then(()=>{
                        if (step !== 'request') {
                            this.getNeedEntity(step, modelId);
                        }
                    });
                },
                complete:()=>{
                    if (show_loader) {
                        $('.bb-preloader-container').hide();
                    }
                },

            });
        }
    },

    getNeedEntity(section_name, entityId=null){
        const section = $('#customer-projects-modal').find(`.project-step.${section_name}`);
        $('#customer-projects-modal').find(`.project-step`).removeClass('fw-500').removeClass('focused');
        if (!section.hasClass('projects')) {
            section.addClass('fw-500').addClass('focused');
        }
        const job_request_id = $('#selected_request').val();
        const entity_id = section_name == ('job-request') ? job_request_id : false;
        if (section.hasClass('projects') || section.hasClass('customer') ) {
            $('#customer-projects-modal').find(`.section.active`).removeClass('active');
            $('#customer-projects-modal').find(`.section.${section_name}`).addClass('active');
        }else{
            this.getEntityInfo(section_name,job_request_id, entityId ?? entity_id);
            const type = $('.section.active')[0].classList[1] == 'job-request' ? 'request' : $('.section.active')[0].classList[1];
            this.scopeDropZone(type,entity_id);
        }
    }
}
